import { toast } from "react-toastify";
import { _post } from "../../Api";

export function updatePostalCodes(taMerchantId, postalCodes, newData) {
  let data = [];
  for (let i in postalCodes) {
    data.push({
      id: postalCodes[i].id,
      ...newData[i],
    });
  }
  return _post("/nova/v2/ta_merchant/" + taMerchantId + "/ta_postal_codes", data)
    .then((res) => {
      let newPostalCodes = [...postalCodes];
      postalCodes.forEach((postalCode, index) => {
        newPostalCodes[index] = { ...postalCode };
        Object.keys(newData[index]).forEach((key) => {
          newPostalCodes[index][key] = res.data[index][key];
        });
      });

      toast.success("Postal codes updated", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    });
}
